import type { FieldError, FieldErrors } from "react-hook-form";

export const resolveFieldError = (
    errors: FieldErrors,
    name?: string,
): FieldError | undefined => {
    if (!name) {
        return undefined;
    }

    const parts = name.split(".");
    let current: unknown = errors;

    for (const part of parts) {
        if (!current || typeof current !== "object") {
            return undefined;
        }
        current = (current as Record<string, unknown>)[part];
    }

    if (!current || typeof current !== "object" || !("message" in current)) {
        return undefined;
    }

    return current as FieldError;
};
